var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 81,
    viewBox: "0 0 400 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.007 81C169.62 81 187.951 62.8878 187.951 40.5454C187.951 18.2029 169.62 0.0907669 147.007 0.0907669C124.394 0.0907669 106.063 18.2029 106.063 40.5454C106.063 62.8878 124.394 81 147.007 81Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.608 37.2653C79.9121 16.4659 62.3622 0.0907669 40.8809 0.0907669C18.3203 0.0907669 -0.000488281 18.2203 -0.000488281 40.5454C-0.000488281 62.8704 18.3203 81 40.8809 81C63.4414 81 79.9121 64.6249 81.608 43.8255H42.2941V37.2399H81.608V37.2653Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.195 80.9092C381.731 80.9092 400 62.7971 400 40.4546C400 18.1121 381.731 0 359.195 0C336.66 0 318.391 18.1121 318.391 40.4546C318.391 62.7971 336.66 80.9092 359.195 80.9092Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.396 20.1637C281.318 8.11127 268.187 0 253.132 0C230.588 0 212.328 18.1296 212.328 40.4546C212.328 62.7797 230.614 80.9092 253.132 80.9092C275.65 80.9092 293.936 62.7797 293.936 40.4546H253.158L288.396 20.1383V20.1637Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBase);
export default __webpack_public_path__ + "static/media/ProfileBase.54b2599fb9a530cb80de7ec881c11225.svg";
export { ForwardRef as ReactComponent };